import React from "react"
import { FormattedMessage } from "react-intl"

import { EditSpan } from "../modals/RunMetadataFieldsModal"
import { Required } from "../../../shared_components/widgets/utils"

export default function FormLabel({ label, description, hasChanged = false, required = false }) {
  return (
    <>
      <label>
        <b>
          <EditSpan show={hasChanged} />
          {label ? (
            <FormattedMessage
              id={`${label}`}
              description={`${description} Field For New Run Form`}
              defaultMessage={description}
            />
          ) : (
            <>{description}</>
          )}
        </b>
        :&nbsp;
        {required && <Required />}
      </label>
      &nbsp;
    </>
  )
}
